import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";
import React from 'react';
import { makeImgResizerUrl } from '@jelly/utils';
import { BMonogram } from '../svgs/BMonogram';

var ThumbnailWrapper = _styled("div", {
  target: "ep0oaly0",
  label: "ThumbnailWrapper"
})(function (_ref) {
  var showBoxShadow = _ref.showBoxShadow;
  return showBoxShadow && "box-shadow:0 18px 22px 0 rgba(29, 45, 51, 0.17)";
}, ";border-radius:", function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'avatar' ? "50%" : "5px";
}, ";height:", function (_ref3) {
  var sizeDimension = _ref3.sizeDimension;
  return "".concat(sizeDimension, "px");
}, ";max-width:", function (_ref4) {
  var sizeDimension = _ref4.sizeDimension;
  return "".concat(sizeDimension, "px");
}, ";width:100%;align-items:center;display:flex;background:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray[400];
}, ";justify-content:space-around;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

/**
 * Thumbnail Component, default will display as a square with rounded corners
 * Takes in any image source and runs it through the image resizer
 * Variants:
 * - primary: square, rounded corners
 * - avatar: round,
 *
 * Size:
 * - small: 50px x 50px
 * - large: 140px x 140px
 *
 *
 * Image defaults to b monogram if no source is given
 * @component
 */
export function Thumbnail(_ref6) {
  var alt = _ref6.alt,
      _ref6$showBoxShadow = _ref6.showBoxShadow,
      showBoxShadow = _ref6$showBoxShadow === void 0 ? false : _ref6$showBoxShadow,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 'small' : _ref6$size,
      src = _ref6.src,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'primary' : _ref6$variant;
  var sizeDimension = size === 'large' ? 140 : 50;
  var pictureSrc = makeImgResizerUrl({
    src: src,
    method: 'rc',
    w: sizeDimension,
    h: sizeDimension
  });
  return /*#__PURE__*/React.createElement(ThumbnailWrapper, _extends({}, src ? {
    as: 'img',
    alt: alt,
    className: 'lazyload',
    'data-src': pictureSrc
  } : {
    children: /*#__PURE__*/React.createElement(BMonogram, {
      height: size === 'large' ? 50 : 25,
      width: size === 'large' ? 50 : 25
    })
  }, {
    showBoxShadow: showBoxShadow,
    sizeDimension: sizeDimension,
    variant: variant
  }));
}